import React, { useState } from "react";
import { useNavigate } from "react-router-dom";

export default function Contact() {
  const [form, setForm] = useState({
    name: "",
    email: "",
    contact_number: "",
    subject: "",
    message: "",
  });

  const [submitted, setSubmitted] = useState(false);
  const [error, setError] = useState("");
  const navigate = useNavigate();

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    try {
      const response = await fetch(`${process.env.REACT_APP_API_URL}/api/contact`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
        body: JSON.stringify(form),
      });
      if (response.ok) {
        setSubmitted(true);
        setTimeout(() => {
          navigate("/");
        }, 2000); // Redirect after 2 seconds
      } else {
        const data = await response.json();
        setError(data.message || "Failed to send message.");
      }
    } catch (err) {
      console.error("Error occurred while submitting the form:", err);
      setError("Network error. Please try again.");
    }
  };

  return (
    <div className="bg-gray-50 min-h-screen flex flex-col items-center py-8 px-4">
      <h2 className="text-2xl sm:text-3xl font-bold text-blue-900 mb-6 text-center">
        Contact Us
      </h2>
      <div className="bg-white rounded-xl shadow-md p-6 w-full max-w-lg">
        {submitted ? (
          <div className="text-green-700 text-center font-semibold">
            Thank you for contacting us! We will get back to you soon.
          </div>
        ) : (
          <form className="flex flex-col gap-4" onSubmit={handleSubmit}>
            {error && (
              <div className="text-red-600 text-center">{error}</div>
            )}
            <input
              type="text"
              name="name"
              placeholder="Your Name"
              className="border rounded-lg px-4 py-2 focus:outline-none focus:ring-2 focus:ring-blue-400"
              value={form.name}
              onChange={handleChange}
              required
            />
            <input
              type="email"
              name="email"
              placeholder="Your Email"
              className="border rounded-lg px-4 py-2 focus:outline-none focus:ring-2 focus:ring-blue-400"
              value={form.email}
              onChange={handleChange}
              required
            />
            <input
              type="text"
              name="contact_number"
              placeholder="Contact Number"
              className="border rounded-lg px-4 py-2 focus:outline-none focus:ring-2 focus:ring-blue-400"
              value={form.contact_number}
              onChange={handleChange}
              required
            />
            <input
              type="text"
              name="subject"
              placeholder="Subject"
              className="border rounded-lg px-4 py-2 focus:outline-none focus:ring-2 focus:ring-blue-400"
              value={form.subject}
              onChange={handleChange}
              required
            />
            <textarea
              name="message"
              placeholder="Your Message"
              rows={4}
              className="border rounded-lg px-4 py-2 focus:outline-none focus:ring-2 focus:ring-blue-400"
              value={form.message}
              onChange={handleChange}
              required
            />
            <button
              type="submit"
              className="bg-blue-700 text-white px-6 py-2 rounded-lg shadow hover:bg-blue-800 transition-colors duration-200"
            >
              Send Message
            </button>
          </form>
        )}
      </div>
    </div>
  );
}
